import React from 'react';
import { Card, CardBody } from 'reactstrap';
import UserGroupForm from '../UserGroupForm';
import ProductManagerList from './ProductManagerList/ProductManagerList';

function UserGroupSettings({
  userGroup,
  onUpdate,
  onAddProductManager,
  onRemoveProductManager,
  cancelUrl,
}) {
  return (
    <>
      <Card>
        <CardBody>
          <UserGroupForm
            submitLabel="Update"
            userGroup={userGroup}
            onSubmit={onUpdate}
            cancelUrl={cancelUrl}
          />
        </CardBody>
      </Card>
      <ProductManagerList
        userGroup={userGroup}
        onAddProductManager={onAddProductManager}
        onRemoveProductManager={onRemoveProductManager}
      />
    </>
  );
}

export default UserGroupSettings;
